import(/* webpackMode: "eager" */ "/home/ubuntu/vizion-analytics/web/src/app/page.tsx");
